export default __webpack_public_path__ + "static/media/next_round.6c566905.svg";